export default __webpack_public_path__ + "d9aa99d0e6308436eff9f2fd43fb48c7.jpg";